import { Component, ElementRef, Renderer2 } from '@angular/core';
import { UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { MultiSelectBase } from '../multi-select-base';

@Component({
  selector: 'app-multi-select-form',
  templateUrl: './multi-select-form.component.html',
  styleUrls: ['./multi-select-form.component.scss'],
  standalone: false,
})
export class MultiSelectFormComponent extends MultiSelectBase {
  constructor(
    renderer: Renderer2,
    utilsService: UtilsService,
    literalService: LiteralService,
    eRef: ElementRef,
  ) {
    super(renderer, utilsService, literalService, eRef);
  }
}
